import { mount } from "../main";
import { IndexPage } from "../pages/IndexPage";

mount(<IndexPage />);
